import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router'

import { routes } from './routes';
import auth from './helpers/auth';

Vue.use(VueResource);

if (process.env.NODE_ENV === 'production') {
  Vue.http.options.root = 'https://sdeveloper.io:3000/';
} else {
  // Vue.http.options.root = 'http://localhost:3000/';
  Vue.http.options.root = 'https://sdeveloper.io:3000/';
}

Vue.http.interceptors.push((req, next) => {
  if (auth.isAuth()) {
    req.headers.set('Authorization', 'Bearer ' + auth.getToken());
  }
  next((response) => {
    if (response.status === 401 && auth.isAuth()) {
      let req = { email: auth.getEmail(), password: auth.getPassword(), keep: true };
      Vue.http.post("auth", req).then(
        _res => _res.json().then(
          (res) => {
            auth.login(req, res);
          }
        )
      );
    }
    else if (response.status === 403) {
      router.replace({ name: "home" });
    }
  })
});

Vue.use(VueRouter);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  vuetify,
  render: h => h(App),
  router
  //mode: 'history',
}).$mount('#app')
